import script from "./AccidentWitnessCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./AccidentWitnessCompleted.vue?vue&type=script&setup=true&lang=js"

import "./AccidentWitnessCompleted.vue?vue&type=style&index=0&id=20aa7f0a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20aa7f0a"]])

export default __exports__